import React from 'react';
import NumberTypePage from './NumberTypePage';

const TwoWayNumbers = () => <NumberTypePage type="twoway" />;

export default TwoWayNumbers;
